export default "__VITE_ASSET__BWB0ZpLh__"